import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlToText'
})
export class HtmlToTextPipe implements PipeTransform {

  transform(value: any): any {
    return value ? String(value).replace(/<[^>]+>/gm, '') : '';
  }

}
